export const PLACES_IDS = [
  'main',
  'main-101',
  'main-102',
  'main-head',
  'main-left',
  'main-right',
  'production',
  'production-1',
  'production-2',
];
